// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".quoteSideInfo .toolbar__content>:not(.btn):not(.menu):last-child,.quoteSideInfo .toolbar__extension>:not(.btn):not(.menu):last-child{margin-right:0}.quoteLifeCycle.v-stepper{background:none!important;box-shadow:none!important}", ""]);
// Exports
module.exports = exports;
